import { Injectable } from '@angular/core';
import { NotificationEndpoint } from './notification-endpoint.service';
declare const $: any;

@Injectable()
export class NotificationService {
    private mainPanel: Element;

    constructor(private notificationEndpoint: NotificationEndpoint) {}

    /**
     * Retrieves app version.
     */
    public getAppVersion<T>() {
        // Send request to the endpoint service
        return this.notificationEndpoint.getAppVersion<T>().toPromise<T>();
    }

    /**
     * Retrieves app feauters.
     * @param version Local app version.
     */
    public getAppFeatures<T>(version: number) {
        // Send request to the endpoint service
        return this.notificationEndpoint.getAppFeatures<T>(version).toPromise<T>();
    }

    public showNotification(dylogType: DialogType, message: string, position: Position, alignment: Alignment, timer?: number) {
        if (this.mainPanel == null) this.init();

        const type = ['', 'info', 'success', 'warning', 'danger', 'rose', 'primary'];
        const from = ['top', 'bottom'];
        const align = ['left', 'center', 'right'];

        // none = 0, info = 1, success = 2, warning = 3, danger = 4, rose = 5, primary = 6
        let defaultTimer: number[] = [3000, 3000, 3000, 10000, 30000, 3000, 3000];

        if (timer == null) timer = defaultTimer[dylogType];

        $.notify(
            {
                icon: 'notifications',
                message: message,
            },
            {
                type: type[dylogType],
                timer: timer,
                placement: {
                    from: from[position],
                    align: align[alignment],
                },
                template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0}" role="alert">' + '<button mat-raised-button type="button" aria-hidden="true" class="close" data-notify="dismiss">  <i class="material-icons">close</i></button>' + '<i class="material-icons" data-notify="icon">notifications</i> ' + '<span data-notify="title">{1}</span> ' + '<span data-notify="message">{2}</span>',
            }
        );
    }

    private init() {
        var mainPanel = document.getElementsByClassName('main-panel')[0];
        $('.modal').on('shown.bs.modal', function () {
            mainPanel.classList.add('no-scroll');
        });
        $('.modal').on('hidden.bs.modal', function () {
            mainPanel.classList.remove('no-scroll');
        });
    }
}

export enum DialogType {
    none = 0,
    info = 1,
    success = 2,
    warning = 3,
    danger = 4,
    rose = 5,
    primary = 6,
}

export enum Position {
    top = 0,
    bottom = 1,
}

export enum Alignment {
    left = 0,
    center = 1,
    right = 2,
}
